import { Component, OnInit, Input } from '@angular/core';
import { IComponentSection } from '../../../interfaces/component-section';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { faUniversity, faCalendar, faAddressCard, faHome } from '@fortawesome/free-solid-svg-icons';
import { faPhone, faBuilding, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';   

@Component({
    selector: 'app-brand-footer-contact-info',
    standalone: true,
    templateUrl: './brand-footer-contact-info.component.html',
    styleUrls: ['./brand-footer-contact-info.component.css'],
    imports: [FontAwesomeModule]
})
export class BrandFooterContactInfoComponent implements OnInit, IComponentSection {

  @Input() data: any;

  brandName!: string;
  brandAddress!: string;
  brandCity!: string;
  brandState!: string;
  brandPostalCode!: string;
  brandEmailAddress!: string;
  brandTelephone!: string;
  brandWebSite!: string;

  isContactInfoVisible: boolean = false;
  isBrandAddressVisible: boolean = false;
  isBrandCityStateZipVisible: boolean = false;
  isBrandEmailAddressVisible: boolean = false;
  isBrandTelephoneVisible: boolean = false;
  isBrandWebSiteVisible: boolean = false;

  faAddressCard = faAddressCard;
  faUniversity = faUniversity;
  faCalendar = faCalendar;
  faHome = faHome;
  faBuilding = faBuilding;
  faEnvelopeOpen = faEnvelopeOpen;
  faPhone = faPhone   

  copyrightYear: number = new Date().getFullYear();
    
  ngOnInit(): void {
    this.makeBrandFooter(this.data);
  }  

  makeBrandFooter (brandInfo: IBrandInfo) {
    console.log('brandInfo', brandInfo);
    this.brandName = brandInfo.brandName;
    if (brandInfo.brandAddress) {
      this.brandAddress = brandInfo.brandAddress;
      this.isBrandAddressVisible = true;
    }
    if (brandInfo.brandCity || brandInfo.brandState || brandInfo.brandPostalCode) {
      this.brandCity = brandInfo.brandCity || '';
      this.brandState = brandInfo.brandState || '';
      this.brandPostalCode = brandInfo.brandPostalCode || '';
      this.isBrandCityStateZipVisible = true;
    }
    if (brandInfo.brandEmailAddress) {
      this.brandEmailAddress = brandInfo.brandEmailAddress;
      this.isBrandEmailAddressVisible = true;
    }
    if (brandInfo.brandTelephone) {
      this.brandTelephone = brandInfo.brandTelephone;
      this.isBrandTelephoneVisible = true;
    }
    if (brandInfo.brandWebSite) {
      this.brandWebSite = brandInfo.brandWebSite;
      this.isBrandWebSiteVisible = true;
    }

    if (this.isBrandAddressVisible || this.isBrandCityStateZipVisible || this.isBrandEmailAddressVisible
        || this.isBrandTelephoneVisible || this.isBrandWebSiteVisible) {
          this.isContactInfoVisible = true;
    }
  } 
}
